import React, { useEffect } from 'react'
import PortfolioAlertSwitch from '../PortfolioAlertSwitch'
import { EDITORIALACCESS } from '../../utils/constants'
import copy from 'copy-to-clipboard'
import { confirmAlert } from 'react-confirm-alert'
import { getHtmlForPdf } from '../../utils/getHtmlForPdf'
import { generateClipboardContent } from '../../utils/generateClipboardContent'
import { pushContentToMatomo } from "../../utils/matomo"

function ShowContentActionButtons ({ contentId, preferences, userRole, userEmail, contentTitle, isEntity, isPortfolio, onPdfButtonClick, apiResponse, contentTypeName, aoi }) {
  var cmsEditContentUrl = `${process.env.CMS_CONTENT_EDIT_URL}`
  var contentActionButtonsToggle = `${process.env.CONTENT_ACTION_BUTTONS_TOGGLE}`
  var baseURL = `${process.env.APP_BASE_URL}`

  useEffect(() => {
    if (apiResponse && apiResponse.error !== '') {
      confirmAlert({
        title: 'PDF Download Failed',
        message: `Sorry, but we have encountered a problem downloading the content to PDF.
Please re-try.  If the problem persists, please contact the MLex Customer Services (customerservices@mlex.com) and provide this error message 
        ${apiResponse.error.toString()}`,
        buttons: [
          {
            label: 'Close',
            onClick: () => { }
          }
        ]
      })

      apiResponse.error = ''
    }
  })

  function print (e) {
    e.preventDefault()
    if(isPortfolio){
      const event = new CustomEvent('expandFilterTimeLine')
      document.dispatchEvent(event)
    }    

    pushToMatomo('print', 'Print')
    
    setTimeout(function () {
      window.print()
    }, 50)
  }

  function pdf (e) {
    e.preventDefault()
    if(isPortfolio){
      const event = new CustomEvent('expandFilterTimeLine')
      document.dispatchEvent(event)
    }  

    pushToMatomo('delivery_download', 'PDF')

    setTimeout(function () {
      generatePdf()
    }, 50)
  }

  function generatePdf () {
    try {
      var request = {
        htmlFiles: [],
        userEmail: userEmail,
        fileType: 'pdf',
        fileName: `MLex_${contentTitle}.pdf`
      }

      request.htmlFiles = [ 
        {
          filename: `MLex_${contentTitle}.pdf`,
          content: getHtmlForPdf(isPortfolio, contentId, 'content')
        }
      ] 

      onPdfButtonClick(request)
    } catch (error) {
      confirmAlert({
        title: 'Pdf generation failed',
        message: `Please contact support team with this error. ${error.toString()}`,
        buttons: [
          {
            label: 'Close',
            onClick: () => { }
          }
        ]
      })
    }
  }

  function copyLink (e) {
    e.preventDefault()
    copy(window.location.href.split('?')[0])

    pushToMatomo('content_permalink', 'Link')

    confirmAlert({
      title: 'Link copied',
      message: 'The link for this page has been copied',
      buttons: [
        {
          label: 'Close',
          onClick: () => { }
        }
      ]
    })
  }

  function copyDocument (e) {
    e.preventDefault()
    if(isPortfolio){
      const event = new CustomEvent('expandFilterTimeLine')
      document.dispatchEvent(event)
    }  

    setTimeout(function () {
      copy(generateClipboardContent(isPortfolio, isEntity, baseURL), { format: 'text/html' })
    }, 50)

    pushToMatomo('content_copytext', 'Copy')

    confirmAlert({
      title: 'Content copied',
      message: 'The article content has been copied',
      buttons: [
        {
          label: 'Close',
          onClick: () => { }
        }
      ]
    })
  }

  function pushToMatomo (uiEvent, uiValue) {
    var  contextData = {
        contentId: contentId,
        articleTitle: contentTitle,
        contentType: contentTypeName,
        areasOfInterest: aoi
    }

    pushContentToMatomo(uiEvent, 'content', 'content_articlepage', 'click', uiValue, contextData)
  }

  return (
    <div className='content-util-buttons'>
      {userRole === EDITORIALACCESS
        ? <a
          className='util-button tooltip editButton' aria-label='Edit content item'
          href={`${cmsEditContentUrl}${contentId}&r=${encodeURIComponent(window.location.href)}`} target='_self' id='editButton'
        >
          <span className='util-button_icon'></span>
          <span>Edit</span>
        </a>
        : null}

      {isPortfolio
        ? preferences && preferences.alertPreferences
          .map((alertPreference, index) =>
            alertPreference.type === 'Portfolio' &&
              <div key={alertPreference.id} className='util-button portfolio-switch tooltip alertsButton' aria-label='Switch alerts on/off for this Portfolio'>
                <PortfolioAlertSwitch
                  portfolioId={Number(contentId)} id={alertPreference.id} name={alertPreference.name} alertPreference={alertPreference}
                  contentTitle={contentTitle} contentTypeName={contentTypeName} areasOfInterest={aoi}
                />
              </div>
          )
        : null}

      {(contentActionButtonsToggle === 'true') &&
        <>
          <a
            className='util-button tooltip linkButton' aria-label='Copy shareable link for this content'
            onClick={e => copyLink(e)} href='#' target='_self' id='copyLinkButton'
          >
            <span className='util-button_icon'></span>
            <span>Link</span>
          </a>
          <a
            className='util-button tooltip copyButton hideInIE' aria-label='Copy all text for this content'
            onClick={e => copyDocument(e)} href='#' target='_self' id='copyDocButton'
          >
            <span className='util-button_icon'></span>
            <span>Copy</span>
          </a>
          <a
            id='pdfButton' href='#' className='util-button tooltip pdfButton'
            aria-label='Download content to PDF' onClick={e => pdf(e)}
          >
            <span className='util-button_icon'></span>
            <span>PDF</span>
          </a>
          <a
            className='util-button tooltip printButton' aria-label='View print-friendly format'
            onClick={e => print(e)} href='#' id='printButton'
          >
            <span className='util-button_icon'></span>
            <span>Print</span>
          </a>
        </>}

    </div>)
}

export default ShowContentActionButtons
